module.exports = __webpack_public_path__ + "img/c0-m.f1802d81.jpg";